// extracted by mini-css-extract-plugin
export default {"landing-block":"LandingBlock_landing-block__PxrEm"};